import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hts_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (
      err.response?.status === 401 &&
      window.location.pathname.startsWith('/admin') &&
      !window.location.pathname.includes('/admin/login')
    ) {
      localStorage.removeItem('hts_token');
      localStorage.removeItem('hts_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('hts_user') || 'null');
  } catch {
    return null;
  }
};
